<script setup>
import Cases from "@/components/Cases.vue";
import MyHeader from "../components/MyHeader.vue";
import Navbar from "@/components/Navbar.vue";
import AboutMe from "@/components/AboutMe.vue";
import Footer from "@/components/Footer.vue";
</script>

<template>
  <section class="">
    <Navbar />
    <MyHeader />
    <Cases/>
    <AboutMe/>
  </section>
</template>

<style lang="scss"></style>
